import React, { useEffect, useMemo, useState, useCallback } from "react";
import ReactDOM from "react-dom/client";
import {
  Select,
  MenuItem,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
} from "@mui/material";
import { ListItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import { mkConfig, generateCsv, download } from "export-to-csv";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Button } from "@mui/material";
import { Grid } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import ReasonCodesPopup from "components/Validate/ReasonCodesPopup";
import { Provider } from "react-redux";
import { store as reduxStore, persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import {
  CUTOFF_ACTION,
  ORDER_ACTIONS,
  PAGE,
} from "components/common/CONSTANTS";
import { showNotificationDialogManualOrder } from "redux/actions/notificationManualOrderAction";
import { processOrders } from "redux/actions/processOrdersActions";
import {
  RESET_CREATE_PROCESS_ORDERS,
  RESET_PROCESS_ORDERS,
  RESET_UPLOAD_MANUAL_ORDER,
} from "redux/actions/action-type";
import { createProcessOrder } from "redux/actions/createProcessOrderAction";
import { resetUploadManualOrder } from "redux/actions/manualUploadActions";
import CutOffTimeAlert from "components/common/cutOffTimeAlert";
import { showNotificationDialog } from "redux/actions/notificationActions";
import { showErrorMessageByCode } from "services/commonServices";

export const ErrorFeedback = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getData, setGetData] = useState([]);
  const [getNewData, setGetNewData] = useState([]);
  const [metadatas, setMetadatas] = useState();
  const [reasonCodesDropdown, setReasonCodesDropdown] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [receivedAction, setReceivedAction] = useState();

  const { reasonCodesResponse } = useSelector((state) => state.reasonCodes);
  const { processOrderResponse } = useSelector((state) => state.processOrders);
  const createProcessOrderResponse = useSelector(
    (state) => state.createProcessOrder.createProcessOrderResponse
  );
  const isCreateProcessOrderError = useSelector(
    (state) => state.createProcessOrder.isCreateProcessOrderError
  );
  const manualOrderUploadResponse = useSelector(
    (state) => state.uploadManualOrderFile.uploadManualOrderResponse
  );
  const isuploadManualOrderSuccess = useSelector(
    (state) => state.uploadManualOrderFile.isuploadManualOrderSuccess
  );
  const isCreateProcessOrderSuccess = useSelector(
    (state) => state.createProcessOrder.isCreateProcessOrderSuccess
  );
  const errMessageForCreate = useSelector(
    (state) => state.createProcessOrder.errorMessage
  );
  const action = location.state?.action;

  useEffect(() => {
    if (action) {
      setReceivedAction(action);
    }
  }, [action]);

  useMemo(() => {
    if (
      createProcessOrderResponse?.metadata &&
      manualOrderUploadResponse.length === 0
    ) {
      dispatch({ type: RESET_PROCESS_ORDERS });
      dispatch({ type: RESET_UPLOAD_MANUAL_ORDER });
      dispatch(resetUploadManualOrder());
      const { metadata, orders } = createProcessOrderResponse;
      if (metadata?.validationfailed > 0) {
        let createObjectWithId = orders?.map((obj, index) => ({
          ...obj,
          id: index + 1,
          ReasonCode: "",
          newItemId: obj?.itemId,
          newPackId: obj?.packId,
          newFromLocation: obj?.shipFromLocationId,
          newToLocation: obj?.shipToLocationId,
          newQuantityOrdered: obj?.quantityOrdered,
          newOrderDate: obj?.orderDate,
        }));
        let manualOrderCreateStringResponse =
          JSON.stringify(createObjectWithId);

        setGetData(JSON.parse(manualOrderCreateStringResponse));
        setGetNewData(JSON.parse(manualOrderCreateStringResponse));
        setMetadatas(metadata);
      }
    }
  }, [dispatch, createProcessOrderResponse, manualOrderUploadResponse]);

  useMemo(() => {
    if (manualOrderUploadResponse && isuploadManualOrderSuccess) {
      dispatch({ type: RESET_PROCESS_ORDERS });
      const { metadata } = manualOrderUploadResponse;

      if (manualOrderUploadResponse?.metadata?.validationfailed) {
        let uploadObjectWithId = manualOrderUploadResponse?.orders?.map(
          (obj, index) => ({
            ...obj,
            id: index + 1,
            ReasonCode: "",
            newItemId: obj?.itemId,
            newPackId: obj?.packId,
            newFromLocation: obj?.shipFromLocationId,
            newToLocation: obj?.shipToLocationId,
            newQuantityOrdered: obj?.quantityOrdered,
            newOrderDate: obj?.orderDate,
          })
        );
        let manualOrderUploadStringResponse =
          JSON.stringify(uploadObjectWithId);
        const { validationfailed } = metadata;
        if (validationfailed && validationfailed > 0) {
          setGetData(JSON.parse(manualOrderUploadStringResponse));
          setGetNewData(JSON.parse(manualOrderUploadStringResponse));
          setMetadatas(metadata);
        }
      }
    }
  }, [dispatch, manualOrderUploadResponse, isuploadManualOrderSuccess]);

  useMemo(() => {
    if (
      action === ORDER_ACTIONS.AMEND ||
      receivedAction === ORDER_ACTIONS.AMEND
    ) {
      dispatch({ type: RESET_CREATE_PROCESS_ORDERS });
      if (Object.hasOwn(processOrderResponse, "metadata")) {
        const { metadata, orders } = processOrderResponse;
        if (metadata.validationfailed > 0) {
          let amendObjectWithId = orders.map((obj, index) => ({
            ...obj,
            id: index + 1,
            ReasonCode: "",
            newItemId: obj?.itemId,
            newPackId: obj?.packId,
            newFromLocation: obj?.shipFromLocationId,
            newToLocation: obj?.shipToLocationId,
            newQuantityOrdered: obj?.quantityOrdered,
            newOrderDate: obj?.orderDate,
          }));
          let manualOrderAmendtringResponse = JSON.stringify(amendObjectWithId);

          setGetData(JSON.parse(manualOrderAmendtringResponse));
          setGetNewData(JSON.parse(manualOrderAmendtringResponse));
          setMetadatas(metadata);
        } else {
          dispatch({ type: RESET_PROCESS_ORDERS });
        }
      }
    }
  }, [action, dispatch, receivedAction, processOrderResponse]);

  useEffect(() => {
    if (isCreateProcessOrderError && errMessageForCreate.httpResponseCode) {
      const { errTitle, errContent } = showErrorMessageByCode(
        createProcessOrderResponse
      );
      dispatch(showNotificationDialog(errTitle, errContent, "Done"));
      setShowLoader(false);
    }
  }, [
    createProcessOrderResponse,
    dispatch,
    errMessageForCreate,
    isCreateProcessOrderError,
  ]);

  const displayErrorPopup = useCallback(() => {
    let multipleErrorsMsg;
    let errorList;
    if (metadatas && manualOrderUploadResponse?.metadata) {
      errorList = [
        `Total number of manual orders = ${manualOrderUploadResponse?.metadata?.totalrecordsRecieved}`,
        `Manual orders created = ${manualOrderUploadResponse?.metadata?.totalrecordsProcessed}`,
      ];
      if (manualOrderUploadResponse?.metadata?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${manualOrderUploadResponse?.metadata?.validationfailed}`
        );
      }
    }
    if (metadatas && manualOrderUploadResponse.metadata === undefined) {
      errorList = [
        `Total number of manual orders = ${metadatas?.totalrecordsRecieved}`,
        `Manual orders created = ${metadatas?.totalrecordsProcessed}`,
      ];
      if (metadatas?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${metadatas?.validationfailed}`
        );
      }
    }

    if (processOrderResponse?.metadata && metadatas) {
      errorList = [
        `Total number of manual orders = ${processOrderResponse?.metadata?.totalrecordsRecieved}`,
        `Manual orders created = ${processOrderResponse?.metadata?.totalrecordsProcessed}`,
      ];
      if (processOrderResponse?.metadata?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${processOrderResponse?.metadata?.validationfailed}`
        );
      }
    }
    if (createProcessOrderResponse?.metadata && metadatas) {
      errorList = [
        `Total number of manual orders = ${createProcessOrderResponse?.metadata?.totalrecordsRecieved}`,
        `Manual orders created = ${createProcessOrderResponse?.metadata?.totalrecordsProcessed}`,
      ];
      if (createProcessOrderResponse?.metadata?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${createProcessOrderResponse?.metadata?.validationfailed}`
        );
      }
    }

    let errorListItems = errorList?.map((x, index) => (
      <ListItem
        dense
        sx={{ p: 0, display: "list-item" }}
        key={index}
      >{`${x}`}</ListItem>
    ));

    if (
      getData &&
      metadatas &&
      (manualOrderUploadResponse?.orders === undefined ||
        manualOrderUploadResponse?.orders?.length === 0)
    ) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual orders submitted successfully with some validation failed
            manual orders, refer below for exact status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Create Status",
          multipleErrorsMsg,
          "Done"
        )
      );
      setShowLoader(false);
    }

    if (
      manualOrderUploadResponse?.orders?.length > 0 ||
      manualOrderUploadResponse?.metadata !== undefined
    ) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual orders file uploaded with some validation failed manual
            orders, refer below for the exact status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Upload Status",
          multipleErrorsMsg,
          "Done"
        )
      );
      setShowLoader(false);
    }
  }, [
    dispatch,
    metadatas,
    getData,
    manualOrderUploadResponse,
    createProcessOrderResponse,
    processOrderResponse,
  ]);

  useEffect(() => {
    let multipleErrorsMsg;
    let errorList;
    if (createProcessOrderResponse?.metadata) {
      errorList = [
        `Total number of manual orders = ${createProcessOrderResponse?.metadata?.totalrecordsRecieved}`,
        `Manual orders created = ${createProcessOrderResponse?.metadata?.totalrecordsProcessed}`,
      ];
      if (createProcessOrderResponse?.metadata?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${createProcessOrderResponse?.metadata?.validationfailed}`
        );
      }
    }
    if (processOrderResponse?.metadata) {
      errorList = [
        `Total number of manual orders = ${processOrderResponse?.metadata?.totalrecordsRecieved}`,
        `Manual orders created = ${processOrderResponse?.metadata?.totalrecordsProcessed}`,
      ];
      if (processOrderResponse?.metadata?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${processOrderResponse?.metadata?.validationfailed}`
        );
      }
    }
    if (manualOrderUploadResponse?.metadata) {
      errorList = [
        `Total number of manual orders = ${manualOrderUploadResponse?.metadata?.totalrecordsRecieved}`,
        `Manual orders created = ${manualOrderUploadResponse?.metadata?.totalrecordsProcessed}`,
      ];
      if (manualOrderUploadResponse?.metadata?.validationfailed !== 0) {
        errorList.push(
          `Validation failed manual orders = ${manualOrderUploadResponse?.metadata?.validationfailed}`
        );
      }
    }

    let errorListItems = errorList?.map((x, index) => (
      <ListItem
        dense
        sx={{ p: 0, display: "list-item" }}
        key={index}
      >{`${x}`}</ListItem>
    ));

    if (
      isCreateProcessOrderSuccess &&
      (manualOrderUploadResponse?.orders === undefined ||
        manualOrderUploadResponse?.orders?.length === 0) &&
      createProcessOrderResponse?.metadata?.validationfailed > 0 &&
      createProcessOrderResponse?.orders?.length > 0
    ) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual orders submitted successfully with some validation failed
            manual orders, refer below for exact status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Submit Status",
          multipleErrorsMsg,
          "Done"
        )
      );
      setShowLoader(false);
    }
    if (
      processOrderResponse &&
      (manualOrderUploadResponse?.orders === undefined ||
        manualOrderUploadResponse?.orders?.length === 0) &&
      processOrderResponse?.metadata?.validationfailed > 0 &&
      processOrderResponse?.orders?.length > 0
    ) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual orders submitted successfully with some validation failed
            manual orders, refer below for exact status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Submit Status",
          multipleErrorsMsg,
          "Done"
        )
      );
      setShowLoader(false);
    }

    if (
      manualOrderUploadResponse?.orders?.length > 0 ||
      manualOrderUploadResponse?.metadata !== undefined
    ) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual orders file uploaded with some validation failed manual
            orders, refer below for the exact status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Upload Status",
          multipleErrorsMsg,
          "Done"
        )
      );
      setShowLoader(false);
    }

    if (
      (isCreateProcessOrderSuccess || processOrderResponse) &&
      (createProcessOrderResponse?.metadata?.validationfailed === 0 ||
        processOrderResponse?.metadata?.validationfailed === 0) &&
      (createProcessOrderResponse?.orders?.length === 0 ||
        createProcessOrderResponse?.orders?.length === undefined ||
        processOrderResponse?.orders?.length === 0 ||
        processOrderResponse?.orders?.length === undefined)
    ) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual Orders submitted successfully, refer below for the exact
            status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
      let url;
      if (processOrderResponse?.metadata?.validationfailed === 0) {
        url = PAGE.AMEND_MANUAL_ORDERS.url;
        dispatch({ type: RESET_PROCESS_ORDERS });
      }
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Submitted Successfully",
          multipleErrorsMsg,
          "Done",
          url
        )
      );
      setShowLoader(false);
    }
    let url;
    if (createProcessOrderResponse?.metadata?.validationfailed === 0) {
      url = PAGE.CREATE_MANUAL_ORDERS.url;
      dispatch(
        showNotificationDialogManualOrder(
          "Manual Orders Submitted Successfully",
          multipleErrorsMsg,
          "Done",
          url
        )
      );
      setShowLoader(false);
    }
  }, [
    dispatch,
    metadatas,
    isCreateProcessOrderSuccess,
    manualOrderUploadResponse,
    processOrderResponse,
    createProcessOrderResponse,
  ]);

  useEffect(() => {
    if (reasonCodesResponse) {
      const { reasonCodes: allReasonCodes } = reasonCodesResponse;
      const filteredReasonCodes = allReasonCodes.filter(
        (reason) => reason.orderType === "Manual Orders"
      );
      const uniqueReasonCodes = Array.from(
        filteredReasonCodes
          .reduce((map, item) => {
            if (!map.has(item.reasonCode)) {
              map.set(item.reasonCode, item);
            }
            return map;
          }, new Map())
          .values()
      );
      const sortedReasonCodes = uniqueReasonCodes.sort(
        (a, b) => a.reasonCode - b.reasonCode
      );
      setReasonCodesDropdown(sortedReasonCodes);
    }
  }, [reasonCodesResponse, setReasonCodesDropdown]);

  useEffect(() => {
    if (
      createProcessOrderResponse ||
      processOrderResponse ||
      manualOrderUploadResponse
    ) {
      displayErrorPopup();
    }

    return () => {
      dispatch({ type: RESET_PROCESS_ORDERS });
    };
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const updateCell = (cell, value, data) => {
    const updatedData = getNewData.map((row) =>
      row.id === cell.row.original.id
        ? { ...row, [cell.column.id]: value }
        : row
    );
    setGetNewData(updatedData);
  };

  const updateCellDate = useCallback(
    (cell, value, date, row) => {
      const updatedData = getNewData?.map((item) =>
        row.original.id === item.id ? { ...item, [value]: date } : item
      );

      setGetNewData(updatedData);
    },
    [getNewData]
  );

  const handleReasonChange = useCallback(
    (id, value, row) => {
      const updatedData = getData?.map((item) =>
        row.id === item.id ? { ...item, [id]: value } : item
      );
      setGetData(updatedData);
      const updatedSetNewData = getNewData?.map((item) =>
        row.id === item.id ? { ...item, [id]: value } : item
      );
      setGetNewData(updatedSetNewData);
    },
    [getData, getNewData]
  );

  const handleExportData = () => {
    const csvConfigNew = mkConfig({
      fieldSeparator: ",",
      decimalSeparator: ".",
      useKeysAsHeaders: true,
      quoteStrings: false,
      useBom: true,
      showColumnHeaders: true,
      filename: "ManualOrder-Failed-Validations",
    });
    const dataForUpload = getNewData.map((items) => {
      let rowData = {
        OrderDate: items?.orderDate
          ? dayjs(items.orderDate).format("YYYYMMDD")
          : "",
        MIN: items.itemId,
        PIN: items.packId,
        FromLocation: items.shipFromLocationId,
        ToLocation: items.shipToLocationId,
        QuantityInCases: items.quantityOrdered,
      };

      if (Array.isArray(items.errors) && items.errors.length > 0) {
        items.errors.forEach((ele) => {
          if (ele.field === "min") {
            rowData.MIN = "E" + items.itemId;
          }
          if (ele.field === "orderDate") {
            rowData.OrderDate = "E" + dayjs(items.orderDate).format("YYYYMMDD");
          }
          if (ele.field === "pin") {
            rowData.PIN = "E" + items.packId;
          }
          if (ele.field === "depot") {
            rowData.FromLocation = "E" + items.shipFromLocationId;
          }
          if (ele.field === "store") {
            rowData.ToLocation = "E" + items.shipToLocationId;
          }
          if (ele.field === "quantity") {
            rowData.QuantityInCases = "E" + items.quantityOrdered;
          }
          if (ele.field === "orderOpportunity") {
            rowData.MIN = "ER" + items.itemId;
            rowData.OrderDate =
              "ER" + dayjs(items.orderDate).format("YYYYMMDD");
            rowData.PIN = "ER" + items.packId;
            rowData.FromLocation = "ER" + items.shipFromLocationId;
            rowData.ToLocation = "ER" + items.shipToLocationId;
            rowData.QuantityInCases = "ER" + items.quantityOrdered;
          }
          if (ele.field === "duplicateOrder") {
            rowData.MIN = "ER" + items.itemId;
            rowData.OrderDate =
              "ER" + dayjs(items.orderDate).format("YYYYMMDD");
            rowData.PIN = "ER" + items.packId;
            rowData.FromLocation = "ER" + items.shipFromLocationId;
            rowData.ToLocation = "ER" + items.shipToLocationId;
            rowData.QuantityInCases = "ER" + items.quantityOrdered;
          }
        });
      }

      return rowData;
    });
    const csv = generateCsv(csvConfigNew)(dataForUpload);
    download(csvConfigNew)(csv);
  };

  const handleDownloadAndReadFile = () => {
    const width = 500;
    const height = 300;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const newWindow = window.open(
      "",
      "_blank",
      `width=${width},height=${height},left=${left},top=${top}`
    );
    if (newWindow) {
      const container = newWindow.document.createElement("div");
      newWindow.document.body.appendChild(container);
      const root = ReactDOM.createRoot(container);
      root.render(
        <Provider store={reduxStore}>
          <PersistGate loading={null} persistor={persistor}>
            <ReasonCodesPopup />
          </PersistGate>
        </Provider>
      );
      newWindow.document.close();
    }
  };

  const formatDateForBackend = (date) => {
    return dayjs(date.$d).format("YYYY-MM-DD"); // Convert to YYYY-MM-DD format
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "tooltip",
        header: "",
        enableEditing: false,
        size: 25,
        Cell: ({ cell }) => {
          const errors = cell.row.original.errors;
          const fields = ["orderOpportunity", "duplicateOrder"];
          const hasError = errors.some((error) => fields.includes(error.field));
          const messages = errors
            .filter((error) => fields.includes(error.field))
            .map((error) => error.message);

          if (hasError) {
            return (
              <div className="ErrorMIN">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                    height: "24px",
                    textAlign: "left",
                  }}
                >
                  <Tooltip title={messages}>
                    <IconButton
                      sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                    >
                      <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </div>
            );
          }
          return <div></div>;
        },
      },
      {
        accessorKey: "id",
        header: "ID",
        enableEditing: false,
        size: 100,
      },
      {
        accessorKey: "itemId",
        header: "Min",
        size: 50,
        required: true,
        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          let field = "min";

          const error = errors.find((err) => err.field === field);
          return {
            disabled: !error,
          };
        },

        Cell: ({ cell }) => {
          const errors = cell.row.original.errors;
          const field = "min";

          const error = errors.find((err) => err.field === field);
          if (error) {
            if (
              error.field === field &&
              cell.row.original.newItemId === cell.row._valuesCache.itemId
            ) {
              return (
                <div className="ErrorMIN">
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      height: "24px",
                      width: "120px",

                      outline: "1px solid red",
                      textAlign: "left",
                    }}
                  >
                    <span>{cell.getValue()}</span>
                    <Tooltip title={error.message}>
                      <IconButton
                        sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div>
              );
            } else if (
              error.field === field &&
              cell.row.original.newItemId !== cell.row._valuesCache.itemId
            )
              return <div>{cell.getValue()}</div>;
          }
          if (!error) {
            return <div>{cell.getValue()}</div>;
          }
        },
      },

      {
        accessorKey: "packId",
        header: "Pin",
        enableEditing: true,
        enableClickToCopy: false,
        size: 50,

        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          let field = "pin";

          const error = errors.find((err) => err.field === field);

          return {
            disabled: !error,
          };
        },
        Cell: ({ cell }) => {
          const errors = cell.row.original.errors;
          const field = "pin";

          const error = errors.find((err) => err.field === field);
          if (error) {
            if (
              error.field === field &&
              cell.row.original.newPackId === cell.row._valuesCache.packId
            ) {
              return (
                <div>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      height: "24px",
                      width: "120px",
                      outline: "1px solid red",
                      textAlign: "left",
                    }}
                  >
                    <span>{cell.getValue()}</span>
                    <Tooltip title={error.message}>
                      <IconButton
                        sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div>
              );
            } else if (
              error.field === field &&
              cell.row.original.newPackId !== cell.row._valuesCache.packId
            )
              return <div>{cell.getValue()}</div>;
          }
          if (!error) {
            return <div>{cell.getValue()}</div>;
          }
        },
      },
      {
        accessorKey: "itemDescription",
        header: "Description",
        enableEditing: false,
        enableClickToCopy: false,
        size: 200,
        Cell: ({ cell }) => {
          return (
            <div>
              <Tooltip title={cell.getValue()} arrow>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    maxWidth: "150px",
                    verticalAlign: "middle",
                  }}
                >
                  {cell.getValue()}
                </span>
              </Tooltip>
            </div>
          );
        },
      },
      {
        accessorKey: "shipFromLocationId",
        header: "Depot",
        size: 40,

        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          let field = "depot";

          const error = errors.find((err) => err.field === field);

          return {
            disabled: !error,
          };
        },
        Cell: ({ cell }) => {
          const errors = cell.row.original.errors;
          const field = "depot";

          const error = errors.find((err) => err.field === field);
          if (error) {
            if (
              error.field === field &&
              cell.row.original.newFromLocation ===
                cell.row._valuesCache.shipFromLocationId
            ) {
              return (
                <div>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      height: "24px",
                      width: "120px",
                      outline: "1px solid red",
                      textAlign: "left",
                    }}
                  >
                    <span>{cell.getValue()}</span>
                    <Tooltip title={error.message}>
                      <IconButton
                        sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div>
              );
            } else if (
              error.field === field &&
              cell.row.original.newFromLocation !==
                cell.row._valuesCache.shipFromLocationId
            )
              return <div>{cell.getValue()}</div>;
          }
          if (!error) {
            return <div>{cell.getValue()}</div>;
          }
        },
      },

      {
        accessorKey: "shipToLocationId",
        header: "Store",
        enableEditing: true,
        size: 40,
        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          let field = "store";

          const error = errors.find((err) => err.field === field);

          return {
            disabled: !error,
          };
        },

        Cell: ({ cell }) => {
          const errors = cell.row.original.errors;
          const field = "store";

          const error = errors.find((err) => err.field === field);
          if (error) {
            if (
              error.field === field &&
              cell.row.original.newToLocation ===
                cell.row._valuesCache.shipToLocationId
            ) {
              return (
                <div>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      height: "24px",
                      width: "120px",
                      outline: "1px solid red",
                      textAlign: "left",
                    }}
                  >
                    <span>{cell.getValue()}</span>
                    <Tooltip title={error.message}>
                      <IconButton
                        sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div>
              );
            } else if (
              error.field === field &&
              cell.row.original.newToLocation !==
                cell.row._valuesCache.shipToLocationId
            )
              return <div>{cell.getValue()}</div>;
          }
          if (!error) {
            return <div>{cell.getValue()}</div>;
          }
        },
      },
      {
        accessorKey: "orderDate",
        header: "Order Date",

        type: Date,
        size: 155,
        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          let field = "orderDate";

          const error = errors.find((err) => err.field === field);

          return {
            disabled: !error,
          };
        },

        Cell: ({ cell, row }) => {
          const errors = cell.row.original.errors;
          let field = "orderDate";

          const error = errors.find((err) => err.field === field);

          const orderDate = cell.row.original?.orderDate;

          const parsedOrderDate = orderDate ? dayjs(orderDate) : null;
          if (
            error &&
            cell.row?.original?.orderDate === cell.row?.original?.newOrderDate
          ) {
            return (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "40px",
                  width: "150px",
                  outline: "1px solid red",
                  textAlign: "left",
                  borderRadius: "4px",
                }}
              >
                <LocalizationProvider>
                  <Tooltip
                    title={error?.message}
                    arrow
                    placement="bottom"
                    PopperProps={{
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 10],
                          },
                        },
                      ],
                    }}
                  >
                    <span>
                      <DatePicker
                        value={parsedOrderDate !== null ? parsedOrderDate : ""} // Controlled value (dayjs object)
                        onChange={(cell) =>
                          updateCellDate(
                            cell,
                            "orderDate",
                            formatDateForBackend(cell),
                            row
                          )
                        }
                        format="DD/MM/YYYY" // Display date in DD/MM/YYYY format
                        disablePast={true} // Disable past dates
                        sx={{ width: "150px" }}
                        size="small"
                        slotProps={{
                          textField: {
                            placeholder: "Order Date",
                            size: "small",
                            inputProps: { 'data-testid': 'order-date-input' },
                          },
                        }}
                      />
                    </span>
                  </Tooltip>
                </LocalizationProvider>
              </Box>
            );
          } else if (
            error &&
            cell.row?.original?.orderDate !== cell.row?.original?.newOrderDate
          ) {
            return (
              <LocalizationProvider>
                <DatePicker
                  value={parsedOrderDate !== null ? parsedOrderDate : ""}
                  onChange={(cell) =>
                    updateCellDate(
                      cell,
                      "orderDate",
                      formatDateForBackend(cell),
                      row
                    )
                  }
                  format="DD/MM/YYYY"
                  disablePast={true}
                  sx={{ width: "150px" }}
                  size="small"
                  slotProps={{
                    textField: {
                      placeholder: "Order Date",
                      size: "small",
                      inputProps: { 'data-testid': 'order-date-input' },
                    },
                  }}
                />
              </LocalizationProvider>
            );
          } else if (!error) {
            return (
              <LocalizationProvider>
                <DatePicker
                  value={parsedOrderDate !== null ? parsedOrderDate : ""}
                  onChange={(cell) =>
                    updateCellDate(
                      cell,
                      "orderDate",
                      formatDateForBackend(cell),
                      row
                    )
                  }
                  format="DD/MM/YYYY"
                  disablePast={true}
                  sx={{ width: "150px" }}
                  size="small"
                  slotProps={{
                    textField: {
                      placeholder: "Order Date",
                      size: "small",
                      inputProps: { 'data-testid': 'order-date-input' },
                    },
                  }}
                />
              </LocalizationProvider>
            );
          }
        },
      },

      {
        accessorKey: "quantityOrdered",
        header: "Quantity in Cases",
        enableEditing: true,
        size: 60,
        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          const fields = ["quantity", "update"];

          const error = errors.find((err) => fields.includes(err.field));

          return {
            disabled: !error,
          };
        },
        Cell: ({ cell }) => {
          const errors = cell.row.original.errors;
          const fields = ["quantity", "update"];

          const error = errors.find((err) => fields.includes(err.field));
          if (error) {
            if (
              cell.row.original.newQuantityOrdered ===
              cell.row._valuesCache.quantityOrdered
            ) {
              return (
                <div>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      height: "24px",
                      width: "120px",
                      outline: "1px solid red",
                      textAlign: "left",
                    }}
                  >
                    <span>{cell.getValue()}</span>
                    <Tooltip title={error.message}>
                      <IconButton
                        sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div>
              );
            } else if (
              fields.includes(error.field) &&
              cell.row.original.newQuantityOrdered !==
                cell.row._valuesCache.quantityOrdered
            )
              return <div>{cell.getValue()}</div>;
          }
          if (!error) {
            return <div>{cell.getValue()}</div>;
          }
        },
      },
      {
        accessorKey: "ReasonCode",
        header: "Quantity Override Reason",
        size: 100,
        muiEditTextFieldProps: ({ row }) => {
          let errors = row.original.errors;
          let fields = ["quantity", "Reason"];

          const error = errors.find((err) => fields.includes(err.field));

          return {
            disabled: !error,
          };
        },
        Cell: ({ cell, row }) => {
          let errors = cell.row.original?.errors;
          let fields = ["Reason", "quantity"];
          const error = errors.filter((err) => fields.includes(err?.field));
          const isDisabled = error?.length > 0 ? false : true;
          let errorMessage = "";
          if (error?.length > 0) {
            error.forEach((item) => {
              if (item.field === "Reason") {
                errorMessage = item?.message;
              }
            });
          } else {
            errorMessage = error[0]?.message;
          }
          return (
            <Tooltip title={errorMessage}>
              <FormControl fullWidth>
                <Select
                  key={cell.row.id}
                  value={cell.row.original?.ReasonCode}
                  className="dropDownValue"
                  onChange={(e) =>
                    handleReasonChange("ReasonCode", e.target.value, row)
                  }
                  displayEmpty
                  disabled={isDisabled}
                  sx={{
                    height: "35px",
                    outline:
                      !isDisabled &&
                      cell.row.original.quantityOrdered ===
                        cell.row.original.newQuantityOrdered
                        ? "1px solid red"
                        : "",
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Reason
                  </MenuItem>
                  {reasonCodesDropdown?.map((reason) => (
                    <MenuItem
                      value={reason?.reasonCode}
                      key={reason?.reasonCodeId}
                    >
                      {reason?.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "deliveryDate",
        header: "Delivery Date",
        enableEditing: false,
        type: Date,
        size: 80,

        Cell: ({ cell }) => {
          if (cell?.row?.original?.deliveryDate !== undefined) {
            return (
              <div>
                {dayjs(cell?.row?.original?.deliveryDate).format("DD/MM/YYYY")}
              </div>
            );
          } else return <div>{""}</div>;
        },
      },
    ],

    [reasonCodesDropdown, handleReasonChange, updateCellDate]
  );

  const table = useMaterialReactTable({
    columns,
    data: getNewData,
    editDisplayMode: "cell",
    enableCellActions: false,
    enableEditing: true,
    enableGlobalFilter: false,
    enableHiding: true,
    enableSorting: false,
    enableColumnFilterModes: false,
    enableBottomToolbar: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enablePagination: false,

    muiEditTextFieldProps: (cell) => ({
      onBlur: (event) => {
        updateCell(cell, event.target.value, getData);
      },
      inputProps: { maxLength: 10 },

      onInput: (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
      },
    }),
    muiTableProps: {
      className: "tableStructure tableStyle labelControl innerTableStyle",
      sx: {
        borderCollapse: "collapse",
      },
    },
    muiTableBodyCellProps: (cell) => ({
      sx: {
        "&:hover": {
          border: "none !important",
        },
      },
    }),
    muiTableBodyRowProps: (data) => {
      const errors = data.row.original.errors;
      const fields = ["orderOpportunity", "duplicateOrder"];

      const hasError = errors.some((error) => fields.includes(error.field));
      return {
        style: hasError
          ? {
              outline: "1px solid red",
            }
          : {},
        sx: {
          "&:hover": {
            border: "none !important",
            borderLeft: "none !important",
            borderRight: "none !important",
            borderTop: "none !important",
            borderBottom: "none !important",
          },
          "& td": {
            padding: "3px",
          },
        },
      };
    },
    muiTableHeadProps: {
      sx: {
        "& tr": {
          backgroundColor: "#004E37",
          "& th": {
            backgroundColor: "#004E37",
            color: "#FFF",
            padding: "7px",
          },
        },
      },
    },
    muiTableContainerProps: {
      sx: {
        maxHeight: "500px",
        overflowY: "auto",
      },
    },

    getRowId: (originalRow) => originalRow.id,
    initialState: { columnVisibility: { id: false } },
  });

  const submitAllData = () => {
    setShowLoader(true);
    const payload = getNewData.map((item) => ({
      manualOrderId: item.manualOrderId,
      packId: item?.packId,
      itemId: item?.itemId,
      packSize: item?.packSize,
      itemDescription: item?.itemDescription,
      shipFromLocationId: item?.shipFromLocationId,
      shipToLocationId: item?.shipToLocationId,
      orderDate: item?.OrderDateUpdated
        ? dayjs(item?.OrderDateUpdated).format("YYYY-MM-DDT00:00:00")
        : dayjs(item?.orderDate).format("YYYY-MM-DDT00:00:00"),
      deliveryDate: item?.deliveryDate,
      quantityOrdered: item?.quantityOrdered,
      reasonCode: item?.ReasonCode,
    }));
    if (receivedAction === ORDER_ACTIONS.AMEND) {
      dispatch(processOrders({ orders: payload, action: ORDER_ACTIONS.AMEND }));
    }
    if (
      receivedAction === ORDER_ACTIONS.CREATE ||
      receivedAction === ORDER_ACTIONS.UPLOAD
    ) {
      dispatch(
        createProcessOrder({ orders: payload, action: ORDER_ACTIONS.CREATE })
      );
    }
  };

  const handleClose = () => {
    navigate(PAGE.HOME.url);
  };

  return (
    <>
      {showLoader && (
        <Dialog open={true} maxWidth="sm" fullWidth={true}>
          <DialogTitle>Submitting Orders</DialogTitle>
          <DialogContent>
            <LinearProgress />
            <Typography>
              To ensure the successful submission, please avoid clicking the
              back button, leaving the page, or refreshing it during the
              submission process.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
      {/* <Grid sx={{ marginBottom: 3 }}>
        <div></div>
      </Grid> */}
      {(getData?.length > 0 || getNewData?.length > 0) &&
        (action === "upload" || action === "create") && (
          <CutOffTimeAlert actionType={CUTOFF_ACTION.create_manual_order} />
        )}
      {(getData?.length > 0 || getNewData?.length > 0) &&
        action === "amend" && (
          <CutOffTimeAlert
            actionType={CUTOFF_ACTION.amend_delete_manual_order}
          />
        )}
      <div>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            marginBottom: 1,
            fontWeight: "bold",
          }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {/* <div style={{ display: "flex", alignItems: "center" }}> */}
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Validation Failed Manual Orders Line Items
            {/* <CutOffTimeAlert actionType={CUTOFF_ACTION.create_manual_order} /> */}
          </Typography>
          {/* {(processOrderResponse || manualOrderUploadResponse) &&
        <CutOffTimeAlert actionType={CUTOFF_ACTION.create_manual_order} />
} */}
          {/* </div> */}
          {/* <Typography><Link style={{ color: "#108810", cursor: "pointer",fontSize:'0.9rem'}} onClick={openListInNewWindow} >View Reasons</Link></Typography>  */}
          <div className="rightAlign">
            <Typography>
              <a
                href="#/"
                style={{
                  color: "#108810",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onClick={handleDownloadAndReadFile}
              >
                Reasons
              </a>
            </Typography>
            <Link
              style={{ color: "#108810", cursor: "pointer", fontSize: "12px" }}
              onClick={displayErrorPopup}
            >
              View Error{" "}
            </Link>
          </div>
        </Box>

        <Grid>
          <Box>
            <MaterialReactTable table={table} />
          </Box>
        </Grid>

        <Grid
          container
          spacing={2}
          alignItems="center"
          className="errorButtons"
        >
          <Grid item xs={4} sm={2} className="paddingTop0">
            <Button
              variant="contained"
              type="button"
              onClick={handleExportData}
              fullWidth // Makes the button take the full width of its container
              style={{ height: "25px", fontSize: "12px", whiteSpace: "nowrap" }}
            >
              Download error records
            </Button>
          </Grid>

          <Grid item xs={8} sm={10} className="paddingTop0">
            <Grid container spacing={1} justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  type="button"
                  onClick={submitAllData}
                  style={{ height: "25px", fontSize: "12px" }}
                >
                  Confirm
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  type="button"
                  onClick={handleClose}
                  style={{ height: "25px", fontSize: "12px" }}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
